// Pure helpers for Site Progress stakeholder links (backend: common/site_share.py).
import { localDay } from '../../lib/localDay';

export const EXPIRY_OPTIONS = [
  { days: 7, label: '7 days' },
  { days: 30, label: '30 days' },
  { days: 90, label: '90 days' },
  { days: 365, label: '1 year' },
];

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "Oct 31, 2026" in Toronto time (where reports are issued); '' for missing/bad input.
export function shortDate(iso) {
  if (!iso) return '';
  if (Number.isNaN(new Date(iso).getTime())) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(localDay(iso));
  if (!m) return '';
  return `${MONTHS[Number(m[2]) - 1]} ${Number(m[3])}, ${m[1]}`;
}

// One short status line per link, e.g. "Live · until Oct 31, 2026 · 3 views".
export function linkLine(link) {
  if (!link) return '';
  const views = Number(link.view_count) || 0;
  const v = `${views} view${views === 1 ? '' : 's'}`;
  if (link.status === 'revoked') return `Turned off ${shortDate(link.revoked_at)} · ${v}`.replace('  ', ' ');
  if (link.status === 'expired') return `Expired ${shortDate(link.expires_at)} · ${v}`;
  return `Live · until ${shortDate(link.expires_at)} · ${v}`;
}

// Live links first (newest first), then dead ones.
export function sortLinks(links) {
  const rank = (l) => (l.status === 'active' ? 0 : 1);
  return [...(links || [])].sort((a, b) => rank(a) - rank(b) || String(b.created_at || '').localeCompare(String(a.created_at || '')));
}

export function placeLine(project) {
  if (!project) return '';
  return [project.address, project.city].filter(Boolean).join(', ');
}
